// extracted by mini-css-extract-plugin
module.exports = {"center-el":"Widget_center-el_3VraN","widget":"Widget_widget_2D-VS"};